<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabChange" v-if="onlinePay">
      <el-tab-pane label="乐沃收银" name="tabCashier">
        <tab-cashier :visible="activeName === 'tabCashier'"></tab-cashier>
      </el-tab-pane>
      <el-tab-pane label="收款记录" name="tabIncome">
        <tab-income :visible="activeName === 'tabIncome'"></tab-income>
      </el-tab-pane>
      <el-tab-pane label="退款记录" name="tabRefund">
        <tab-refund :visible="activeName === 'tabRefund'"></tab-refund>
      </el-tab-pane>
    </el-tabs>
    <!-- 未开通乐沃收银 -->
    <div v-else>
      <!-- 未提交资料 -->
      <div class="not-apply-wrap" v-if="applyStatus === 1">
        <div class="info">
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/notOpen.png"
            alt=""
          />
          <div class="text">还未申请开通乐沃收银</div>
        </div>
        <div class="buttons">
          <div class="btn" @click="handleApply">立即开通</div>
        </div>
      </div>
      <!-- 已提交资料 -->
      <div class="apply-wrap" v-if="applyStatus === 2">
        <div class="info">
          <div class="title">开通乐沃收银</div>
        </div>
        <div v-html="applyContent.content" class="content"></div>
        <div class="buttons">
          <div class="btn" @click="handleAgreement">立即开通</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabCashier from "./cashier";
import tabIncome from "./income";
import tabRefund from "./refund";
import { UserModule } from "@/store/module/user";
import {
  applyStatusApi,
  applyClickApi,
  applyDetailApi,
} from "@/api/storeWallet";
export default {
  components: {
    tabCashier,
    tabIncome,
    tabRefund,
  },
  data() {
    return {
      activeName: "tabCashier",
      applyContent: "",
      applyStatus: 0,
      cateID: "",
    };
  },
  created() {
    if (this.onlinePay) {
      if (this.$route.query.tab) {
        this.activeName = this.$route.query.tab;
      } else {
        let pageCache = sessionStorage.getItem(
          "finance-center-store-wallet-page-cache"
        );
        if (pageCache) {
          let pageCacheJSON = JSON.parse(pageCache);
          if (pageCacheJSON.tab) {
            this.activeName = pageCacheJSON.tab;
          }
        }
      }
    } else {
      // 未开通线上支付，走开通流程，如果提交过支付申请，直接跳转到协助资料页
      applyStatusApi().then((res) => {
        if (res.data.cate_id === 3) {
          this.$router.push({
            name: "storeWalletAssistment",
          });
        } else {
          this.applyStatus = 1;
          this.cateID = res.data.cate_id;
        }
      });
    }
  },
  computed: {
    onlinePay: () => {
      return UserModule.userInfo.online_pay;
    },
  },
  methods: {
    tabChange(v) {
      sessionStorage.setItem(
        "finance-center-store-wallet-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
    handleApply() {
      applyDetailApi({
        cate_id: this.cateID,
      }).then((res) => {
        this.applyStatus = 2;
        this.applyContent = res.data.info;
        // 未开通的门店，都需要要进行点击数上报
        applyClickApi({
          article_id: res.data.info.id,
        }).then(() => {});
      });
    },
    handleAgreement() {
      this.$router.push({
        name: "storeWalletAgreement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  min-height: calc(100vh - 79px);
  /deep/.el-tabs__active-bar {
    transition: none;
  }
  .not-apply-wrap {
    text-align: center;
    .info {
      margin-bottom: 5px;
      padding-top: 25vh;
      img {
        width: 52px;
        height: 50px;
      }
      .text {
        font-size: 14px;
        margin: 11px 0;
      }
    }
    .buttons {
      .btn {
        margin: 0 auto;
        background: #07d1aa;
        color: white;
        width: 84px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 5px;
      }
      .btn:hover {
        cursor: pointer;
      }
    }
  }
  .apply-wrap {
    text-align: center;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 79px);
    .info {
      .title {
        font-weight: 700;
        font-size: 18px;
        margin: 30px 0;
        color: #303133;
      }
    }
    /deep/.content {
      flex: 1;
      border: 1px solid #c1c1c1;
      overflow-y: auto;
      height: 0;
      p {
        font-size: 16px !important;
      }
      img {
        max-width: 100%;
      }
      &::-webkit-scrollbar {
        width: 4px;
        height: 8px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #c1c1c1;
        border-radius: 4px;
      }
    }
    .buttons {
      margin-top: 12px;
      .btn {
        margin: 0 auto;
        background: #07d1aa;
        color: white;
        width: 84px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 5px;
      }
      .btn:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
